import { useEffect } from "react";

// Fetches pictures ahead of time so stepping to the next slide or image shows
// it at once instead of after a download. Does nothing offline: there the
// pictures come from the copy saved on the phone.
export function usePreloadImages(urls: (string | undefined)[]) {
  const key = urls.filter(Boolean).join("\n");
  useEffect(() => {
    if (!key || (typeof navigator !== "undefined" && navigator.onLine === false)) return;
    for (const url of key.split("\n")) {
      const image = new Image();
      image.src = url;
    }
  }, [key]);
}
